module.exports = __webpack_public_path__ + "img/qrcode-solid.0d37752a.svg";